<script>
    import Flatpickr from 'svelte-flatpickr';
    import { date } from '../store/search';

    export let placeholder;
    export let onRequest;

    const flatpickrOptions = {
        element: '#my-picker',
        enableTime: false,
        altInput: true,
        minDate: onRequest
            ? new Date().setDate(new Date().getDate() + 2)
            : new Date(),
        wrap: true,
        altFormat: 'Y-m-d',
        dateFormat: 'Y-m-d',
        disableMobile: true,
    };
</script>

<svelte:head>
    <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css"
    />
</svelte:head>

<Flatpickr options={flatpickrOptions} bind:value={$date} element="#my-picker">
    <div class="flatpickr date-time-field" id="my-picker">
        <input type="text" {placeholder} data-input />
    </div>
</Flatpickr>
